export const clientId = '881083565546-uc9odigecpu9lkj7t6ddspaskdk5depa.apps.googleusercontent.com'
// Google sign in for server side apps 
export const scopes = 'https://www.googleapis.com/auth/gmail.settings.basic https://www.googleapis.com/auth/calendar.readonly' 
